import { z } from "zod";

export const getCustomerCreateFormSchema = () => {
	return z.object({
		name: z.string(),
		phone: z.string(),
		email: z.string().email(),
	});
};

export type CustomerCreateFormModel = z.infer<
	ReturnType<typeof getCustomerCreateFormSchema>
>;
